<template>
  <div class="grouped-table-items">
    <div
      v-show="hasOverflow"
      class="scroll-top"
      ref="topRef"
      @scroll="onTopScroll"
    >
      <div class="scroll-content" :style="{ width: `${scrollWidth}px` }"></div>
    </div>
    <div ref="hostRef">
      <a-table
        :data-source="items"
        :columns="columns"
        :row-key="rowKey"
        :pagination="false"
        :scroll="{ x: 'max-content' }"
      >
        <template
          v-for="slotName in forwardedSlots"
          :key="slotName"
          #[slotName]="slotProps"
        >
          <slot :name="slotName" v-bind="slotProps" :group="group" />
        </template>
      </a-table>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, useSlots, watch } from 'vue';
import useTopScrollSync from '@/composables/use-top-scroll-sync';

const props = defineProps({
  group: {
    type: Object,
    required: true
  },
  items: {
    type: Array,
    default: () => []
  },
  columns: {
    type: Array,
    default: () => []
  },
  rowKey: {
    type: [String, Function],
    default: 'key'
  }
});

const slots = useSlots();
const forwardedSlots = computed(() => Object.keys(slots));

const { topRef, hostRef, scrollWidth, hasOverflow, onTopScroll, refresh } =
  useTopScrollSync();

watch(() => props.items, refresh);
</script>

<style scoped>
.scroll-top {
  height: 18px;
  margin-bottom: 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  border-radius: 6px;
}

.scroll-content {
  height: 1px;
}
</style>
